// <!-- SMARTRR_CUSTOMIZED_NO_AUTO_EDIT -->
if (!window.smartrr) {
  window.smartrr = {};
}

window.smartrr.product = function (options) {
  var selectors = {
    newPrice: ".smartrr-new-price",
    newPriceSubscriptionDiscount: ".smartrr-new-price-subscription-discount",
    sellingPlanGroup: ".smartrr-selling-plan-group",
    sellingPlanGroupContents: ".smartrr-selling-plan-group-contents",
    noPlansAvailable: ".smartrr-no-plans-available",
  };

  var formSelector = options.formSelector;
  var sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;
  var sellingPlanIdInputSelector = options.sellingPlanIdInputSelector;
  var priceContainerSelector = options.priceContainerSelector;
  var regularPriceSelector = options.regularPriceSelector;
  var salePriceSelector = options.salePriceSelector;
  var variantSelectorSelector = options.variantSelectorSelector;

  var product = options.product;
  var groupToSellingPlans = options.groupToSellingPlans;
  var variantToPrice = options.variantToPrice;
  var variantToSellingPlanAllocations = options.variantToSellingPlanAllocations;
  var priceDisplayMode = options.priceDisplayMode || "strike";
  var showSubscriptionDiscountBadge = !!options.showSubscriptionDiscountBadge;

  var $form;
  var $sellingPlanIdInput;

  var variantsHandler;
  var priceDisplayHandler;
  var sellingPlanGroupsHandler;
  var quantityHandler;

  document.body.classList.add(
    "smartrr-theme-" + encodeURIComponent(options.theme.toLowerCase().replace(/s/g, "-"))
  );
  document.addEventListener("DOMContentLoaded", initialize);

  function initialize() {
    $form = document.querySelector(formSelector);
    $sellingPlanIdInput = document.querySelectorAll(sellingPlanIdInputSelector);

    if ($form === null || !$sellingPlanIdInput.length) {
      throw new Error(createErrorMessage("One or more elements required for Smartrr were not found."));
    }

    variantsHandler = new VariantsHandler({
      selector: variantSelectorSelector,
      product: product,
    });

    sellingPlanGroupsHandler = new SellingPlanGroupsHandler({
      variantsHandler: variantsHandler,
      sellingPlanGroupsSelector: sellingPlanGroupsSelector,
    });

    if (options.quantitySelector && document.querySelector(options.quantitySelector)) {
      quantityHandler = new QuantityHandler({ selector: options.quantitySelector });
      quantityHandler.on("updateQuantity", function () {
        priceDisplayHandler.update();
      });
    }

    priceDisplayHandler = new PriceDisplayHandler({
      variantsHandler: variantsHandler,
      sellingPlanGroupsHandler: sellingPlanGroupsHandler,
      quantityHandler: quantityHandler,
      product: product,
      selector: priceContainerSelector,
      regularPriceSelector: regularPriceSelector,
      salePriceSelector: salePriceSelector,
      displayMode: priceDisplayMode,
      showBadge: showSubscriptionDiscountBadge,
    });

    variantsHandler.on("updateVariant", function () {
      sellingPlanGroupsHandler.update();
      priceDisplayHandler.update();
    });

    sellingPlanGroupsHandler.on("updatePlanId", function (e) {
      var planId = e.detail.planId;
      $sellingPlanIdInput.forEach(function ($input) {
        $input.setAttribute("value", planId || "");
      });
      priceDisplayHandler.update();
    });
    
    document.querySelectorAll("form[action='/cart'] input,form[action='/cart'] button").forEach(function($el) {
      $el.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/checkout';
      });
    });
    
//     document.querySelectorAll('.smartrr-button-subscribe').forEach(function($el) {
//       $el.addEventListener('click', function(e) {
//         // override default CartJS behavior to include selling plan id
//         if (typeof CartJS !== 'undefined' && CartJS.Core) {
//           CartJS.Core.addItem = function(id, quantity, properties, options) {
//             var data;
//             if (quantity == null) {
//               quantity = 1;
//             }
//             if (properties == null) {
//               properties = {};
//             }
//             if (options == null) {
//               options = {};
//             }
//             data = CartJS.Utils.wrapKeys(properties);
//             data.id = id;
//             data.quantity = quantity;
//             data.selling_plan = getCurrentSellingPlanId();
//             CartJS.Queue.add('/cart/add.js', data, options);
//             return CartJS.Core.getCart();
//           };
//         }
//       }, true);
//     });
  }

  /* data getters */
  function getCurrentSellingPlanId() {
    return $sellingPlanIdInput[0].getAttribute("value");
  }

  function getCurrentSellingPlan() {
    var currentPlanId = getCurrentSellingPlanId();
    var groupId = sellingPlanGroupsHandler.getCurrentGroupId();

    if (!groupId) {
      return "";
    }

    return groupToSellingPlans[groupId].find(function (plan) {
      return Number(plan.id) === Number(currentPlanId);
    });
  }

  function getPlanAllocationFormattedPriceFromVariantAndPlanId(variantId, planId, quantity) {
    var sellingPlanAllocation = variantToSellingPlanAllocations[variantId].find(function (alloc) {
      return Number(alloc.sellingPlanId) === Number(planId);
    });

    return sellingPlanAllocation ? formatMoney(sellingPlanAllocation.priceWithDecimals * quantity) : "";
  }

  function SellingPlanGroupsHandler(options) {
    this.variantsHandler = options.variantsHandler;
    this.sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;

    this.$sellingPlanGroupsContainer = document.querySelector(options.sellingPlanGroupsSelector);
    this.$radioInputs = Array.from(this.$sellingPlanGroupsContainer.querySelectorAll('input[type="radio"]'));

    this.dispatcher = new EventTarget();

    if (this.$radioInputs.length) {
      this.$radioInputs[0].click();
    }

    var that = this;
    this.$radioInputs.forEach(function ($input) {
      $input.addEventListener("change", function (e) {
        var groupId = e.currentTarget.value || "";

        that._showGroupContents(groupId);
        if (groupId) {
          that.update();
           // var planId = that._getSelectedPlanIdFromGroupId(groupId);
          // that._dispatchPlanId(planId ? "" + planId : "");
          that._selectFirstEnabledPlanForGroup(groupId);
        } else {
          that._dispatchPlanId("");
        }
      });
    });

    this._getAllSelingPlanGroupPlanSelectors().forEach(function ($selector) {
      $selector.addEventListener(
        "change",
        function (e) {
          this._dispatchPlanId(e.currentTarget.value);
        }.bind(this)
      );
    }, this);

    this.update();
    
    if (this.$radioInputs.length) {
      var groupId = this.$radioInputs[0].value || "";

        that._showGroupContents(groupId);
        if (groupId) {
          that.update();
           // var planId = that._getSelectedPlanIdFromGroupId(groupId);
          // that._dispatchPlanId(planId ? "" + planId : "");
          that._selectFirstEnabledPlanForGroup(groupId);
        } else {
          that._dispatchPlanId("");
        }
    }
  }

  SellingPlanGroupsHandler.prototype = Object.assign({}, SellingPlanGroupsHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    update: function () {
      var variant = this.variantsHandler.getCurrentVariant();
      var variantId = variant ? variant.id : "";
      var variantHasAnyPlans = variant && variantToSellingPlanAllocations[variant.id].length;

      if (!variant || (variant.requires_selling_plan && !variantHasAnyPlans)) {
        show(this._getNoPlansMessage());
        hide(this.$sellingPlanGroupsContainer);
        this._dispatchPlanId("");
        return;
      } else {
        hide(this._getNoPlansMessage());
        show(this.$sellingPlanGroupsContainer);
      }

      this.$radioInputs.forEach(function ($radio) {
        var groupId = $radio.value;
        if (this._isOTP(groupId)) return;

        var variantSellingPlans = this._getSellingPlansForVariantAndGroup(variantId, groupId);

        var $options = this._getGroupPlanSelectorOptions(groupId);
        $options.forEach(function ($option) {
          var variantHasSellingPlan = variantSellingPlans.find(function (plan) {
            return Number(plan.id) === Number($option.value);
          });
          setElementDisabled($option, !variantHasSellingPlan);
        });

        if (
          $radio.checked &&
          variantSellingPlans.length &&
          !variantSellingPlans.find(function (plan) {
            return Number(plan.id) === Number(getCurrentSellingPlanId());
          })
        ) {
          this._selectFirstEnabledPlanForGroup(groupId);
        }

        if ($radio.checked && !variantSellingPlans.length && !variant.requires_selling_plan) {
          this._getOTPRadioInput().click();
        }

        setElementDisabled($radio, !variantSellingPlans.length);
      }, this);
    },

    getCurrentGroupId: function () {
      var $checkedRadio = this.$radioInputs.find(function ($radio) {
        return $radio.checked === true;
      });
      return $checkedRadio ? $checkedRadio.value : "";
    },

    getCurrentPlanId: function () {
      return this._getSelectedPlanIdFromGroupId(this.getCurrentGroupId());
    },

    _dispatchPlanId: function (planId) {
      return this.dispatcher.dispatchEvent(
        new CustomEvent("updatePlanId", {
          detail: { planId: planId },
        })
      );
    },

    _getSellingPlansForVariantAndGroup: function (variantId, groupId) {
      if (!groupId) return [];
      return groupToSellingPlans[groupId].filter(function (plan) {
        return variantToSellingPlanAllocations[variantId].find(function (alloc) {
          return plan.id === alloc.sellingPlanId;
        });
      });
    },

    _getOTPRadioInput: function () {
      return this.$radioInputs.find(function ($radio) {
        return !$radio.value;
      });
    },

    _getGroups: function () {
      return Array.from(document.querySelectorAll(selectors.sellingPlanGroup));
    },

    _getAllSelingPlanGroupPlanSelectors: function () {
      return Array.from(this.$sellingPlanGroupsContainer.querySelectorAll("select"));
    },

    _getGroupPlanSelector: function (group) {
      var $group = typeof group === "string" ? this._getGroupElementFromGroupId(group) : group;
      return $group.querySelector("select");
    },

    _getGroupPlanSelectorValue: function ($group) {
      var $selector = this._getGroupPlanSelector($group);
      var groupId = this._getGroupIdFromGroupElement($group);
      return $selector ? Number($selector.value) : groupToSellingPlans[groupId][0].id;
    },

    _getSelectedPlanIdFromGroupId: function (groupId) {
      var $group = this._getGroupElementFromGroupId(groupId);
      return this._getSelectedPlanIdFromGroup($group);
    },

    _getSelectedPlanIdFromGroup: function ($group) {
      var $planSelector = this._getGroupPlanSelector($group);
      var groupId = this._getGroupIdFromGroupElement($group);

      if (groupToSellingPlans[groupId].length <= 1) {
        return groupToSellingPlans[groupId][0].id || null;
      }

      return $planSelector ? $planSelector.value : null;
    },

    _getGroupPlanSelectorOptions: function (group) {
      var $selector = this._getGroupPlanSelector(group);
      return $selector ? Array.from($selector.querySelectorAll("option")) : [];
    },

    _getGroupContents: function ($group) {
      return $group.querySelector(selectors.sellingPlanGroupContents);
    },

    _getGroupIdFromGroupElement: function ($group) {
      return $group.getAttribute("data-group-id");
    },

    _getGroupElementFromGroupId: function (groupId) {
      return $form.querySelector("[data-group-id='" + groupId + "']");
    },

    _selectFirstEnabledPlanForGroup: function (group) {
      var $selector = this._getGroupPlanSelector(group);
      var $options = this._getGroupPlanSelectorOptions(group);
      var $firstEnabledOption = $options.find(function ($option) {
        return !$option.getAttribute("disabled");
      });
      $selector.value = $firstEnabledOption.value;
      this._dispatchPlanId($firstEnabledOption.value);
    },

    _isOTP: function (groupId) {
      return !groupId;
    },

    _showGroupContents: function (groupId) {
      var $groups = this._getGroups();
      var $groupToShow = $groups.find(
        function ($group) {
          return (this._getGroupIdFromGroupElement($group) || "") === groupId;
        }.bind(this)
      );

      $groups.forEach(
        function ($group) {
          var $contents = this._getGroupContents($group);
          if (!$contents) return;
          $group === $groupToShow ? show($contents) : hide($contents);
        }.bind(this)
      );

      if (!groupId) {
        this._dispatchPlanId(""); // OTP
      } else if ($groupToShow) {
        this._dispatchPlanId(this._getGroupPlanSelectorValue($groupToShow));
      }
    },

    _getNoPlansMessage: function () {
      return $form.querySelector(selectors.noPlansAvailable);
    },
  });

  function PriceDisplayHandler(options) {
    this.variantsHandler = options.variantsHandler;
    this.sellingPlanGroupsHandler = options.sellingPlanGroupsHandler;
    this.quantityHandler = options.quantityHandler;
    this.product = options.product;
    this.displayMode = options.displayMode;
    this.showBadge = options.showSubscriptionDiscountBadge;
    this.selector = options.selector;

    this.$container = document.querySelector(options.selector);
    if (!this.$container) {
      this.update();
      return;
    }
  }

  PriceDisplayHandler.prototype = Object.assign({}, PriceDisplayHandler.prototype, {
    update: function () {      
      var groupShown = $('[data-group-id]').first().attr('data-group-id');
      var currentVariant = this.variantsHandler.getCurrentVariant();
      var sellingPlan = currentVariant.selling_plan_allocations.find(function(plan) {
        return String(plan.selling_plan_group_id) === String(groupShown);
      });
            
      var normalPrice = formatMoney(sellingPlan.compare_at_price / 100);
      var subscribePrice = formatMoney(sellingPlan.per_delivery_price / 100);
      
      $('.price_otp').text(normalPrice);
      $('.price_subscribe').text(subscribePrice);
    },

    _createNewPriceContainer: function ($priceEl, priceType, displayMode) {
      if (priceType !== "regular" && priceType !== "sale") {
        throw new Error(createErrorMessage("Invalid price type."));
      }

      if (!$priceEl) {
        return null;
      }

      var $newPriceContainer = createElement(
        "div",
        ["smartrr-new-price-container"],
        {},
        { "data-price-type": priceType }
      );

      var $discount = createElement("div", ["smartrr-new-price-subscription-discount"], {
        borderColor: document.body.color,
      });

      $priceEl.insertAdjacentElement("afterend", $newPriceContainer);
      updateText($priceEl, $priceEl.innerText.trim());

      if (displayMode === "strike") {
        var $newPrice = document.createElement("div");
        $newPrice.classList.add("smartrr-new-price");
        $newPriceContainer.appendChild($newPrice);
      }

      if (this.showBadge) {
        $newPriceContainer.appendChild($discount);
      }

      return $newPriceContainer;
    },

    _getActivePrice: function () {
      if (!isHidden(this.$regularPrice)) {
        return this.$regularPrice;
      } else if (!isHidden(this.$salePrice)) {
        return this.$salePrice;
      } else {
        throw new Error(createErrorMessage("Couldn't get visible price display."));
      }
    },

    _getActiveNewPriceContainer: function () {
      if (!isHidden(this.$newRegularPriceContainer)) {
        return this.$newRegularPriceContainer;
      } else if (!isHidden(this.$newSalePriceContainer)) {
        return this.$newSalePriceContainer;
      } else {
        throw new Error(createErrorMessage("Couldn't get visible new price display."));
      }
    },

    _overwrite: function (amountText) {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      updateText($price, amountText);

      var $activeContainer =
        priceType === "regular" ? this.$newRegularPriceContainer : this.$newSalePriceContainer;
      var $inactiveContainer =
        priceType === "regular" ? this.$newSalePriceContainer : this.$newRegularPriceContainer;
      if (!this.sellingPlanGroupsHandler.getCurrentGroupId()) {
        hide($activeContainer);
        hide($inactiveContainer);
      } else {
        this._updateNewPriceDiscount($activeContainer, getCurrentSellingPlan());
        show($activeContainer);
        hide($inactiveContainer);
      }
    },

    _strike: function (amountText) {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      var $activeContainer =
        priceType === "regular" ? this.$newRegularPriceContainer : this.$newSalePriceContainer;
      var $inactiveContainer =
        priceType === "regular" ? this.$newSalePriceContainer : this.$newRegularPriceContainer;
      if (!$activeContainer) {
        throw new Error(createErrorMessage("Failed to retrieve new price container."));
      }

      strikeText(priceType === "regular" ? this.$regularPrice : this.$salePrice, true);

      this._setNewPrice($activeContainer, amountText);
      this._updateNewPriceDiscount($activeContainer, getCurrentSellingPlan());

      show($activeContainer);
      hide($inactiveContainer);

      if (this.$container.querySelector(".price__sale")) {
        // debut
        this.$container
          .querySelector(".price__sale")
          .querySelectorAll("[data-regular-price]")
          .forEach(function ($el) {
            priceType === "sale" ? hide($el) : show($el);
          });
      }
    },

    _unstrike: function () {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      strikeText($price, false);
      try {
        var $container = this._getActiveNewPriceContainer();
        hide($container);
      } catch (e) {
        //
      }

      if (this.$container.querySelector(".price__sale")) {
        // debut
        this.$container
          .querySelector(".price__sale")
          .querySelectorAll("[data-regular-price]")
          .forEach(function ($el) {
            priceType === "sale" ? show($el) : hide($el);
          });
      }
    },

    _setNewPrice: function ($container, amountText) {
      var $newPrice = $container.querySelector(selectors.newPrice);
      if ($newPrice) updateText($newPrice, amountText);
    },

    _updateNewPriceDiscount: function ($container, sellingPlan) {
      if (!sellingPlan) {
        return;
      }

      var $discount = $container.querySelector(selectors.newPriceSubscriptionDiscount);
      if (!$discount) {
        return;
      }

      var discountValue = sellingPlan.price_adjustments[0].value;
      if ($discount && discountValue) updateText($discount, "Subscription - save " + discountValue + "%");
    },
  });

  function VariantsHandler(options) {
    this.product = options.product;
    this.selector = options.selector;

    this.dispatcher = new EventTarget();

    this.$options = Array.from(document.querySelectorAll(options.selector));

    var that = this;
    this.$options.forEach(function ($option) {
      var type = $option.getAttribute("type");
      var tagName = $option.tagName.toLowerCase();
      $option.addEventListener(type === "button" ? "click" : "change", function () {
        setTimeout(function () {
          that._dispatchVariant(that.getCurrentVariant());
        }, 10);
      });
    });
  }

  VariantsHandler.prototype = Object.assign({}, VariantsHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    getCurrentVariant: function () {
      var selectedOptions = this._getSelectedOptions();
      var variant = this.product.variants.find(function (variant) {
        return selectedOptions.every(function (values) {
          return variant[values.index] === values.value;
        });
      });

      return variant;
    },

    _dispatchVariant: function (variant) {
      this.dispatcher.dispatchEvent(
        new CustomEvent("updateVariant", {
          detail: variant,
        })
      );
    },

    _getSelectedOptions: function () {
      return this.$options.reduce(function (acc, $option, arrayIndex) {
        var tagName = $option.tagName.toLowerCase();
        var type = $option.getAttribute("type");
        var isSelectedButton = type === "button" && (
          hasSelectedOrActiveClass($option) || 
          !!getParentElementsUntilTrue($option, function($parent) { return hasSelectedOrActiveClass($parent); })
        );
        var isRadioCheckboxOrButton = type === "radio" || type === "checkbox" || type === "button" || tagName === "div";

        if (!isRadioCheckboxOrButton || isSelectedButton || $option.checked) {
          return acc.concat({
            value: $option.getAttribute("data-variant-title") || $option.value,
            index: $option.getAttribute("data-index") || "option" + (arrayIndex + 1),
          });
        } else {
          return acc;
        }
      }, []);
    },
  });

  function QuantityHandler(options) {
    this.selector = options.selector;

    this.dispatcher = new EventTarget();

    var $quantity = document.querySelector(options.selector);
    if (!$quantity) {
      return;
    }

    var that = this;
    if ($quantity instanceof HTMLSelectElement) {
      $quantity.addEventListener("change", function (e) {
        that._dispatchQuantity(that.getQuantity());
      });
    } else {
      $quantity.addEventListener("DOMSubtreeModified", function () {
        setTimeout(function () {
          that._dispatchQuantity(that.getQuantity());
        }, 10);
      });
    }
  }

  QuantityHandler.prototype = Object.assign({}, QuantityHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    getQuantity: function () {
      var $quantity = document.querySelector(this.selector);
      if (!$quantity) {
        return;
      }

      return $quantity instanceof HTMLSelectElement || $quantity instanceof HTMLInputElement ? Number($quantity.value) : Number($quantity.innerText);
    },

    _dispatchQuantity: function (quantity) {
      this.dispatcher.dispatchEvent(
        new CustomEvent("updateQuantity", {
          detail: { quantity },
        })
      );
    },
  });

  /* utilities */
  function formatMoney(value) {
    return Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
    }).format(value);
  }

  function createElement(tag, classList, style, attributes) {
    var $el = document.createElement(tag);
    (classList || []).forEach(function (cls) {
      $el.classList.add(cls);
    });

    $el.style = Object.assign($el.style, style || {});
    Object.keys(attributes || {}).forEach(function (attribute) {
      $el.setAttribute(attribute, attributes[attribute]);
    });

    return $el;
  }
  
  function getParentElementsUntilTrue($el, callback) {
    var $currentElement = $el;
    while ($currentElement !== null) {
      $currentElement = $currentElement.parentElement;
      if (callback($currentElement)) {
       	break; 
      }
    }
    return $currentElement;
  }

  function setElementDisabled($el, disabled) {
    if (!$el) return;
    if (disabled) {
      $el.setAttribute("disabled", true);
    } else {
      $el.removeAttribute("disabled");
    }
  }
        
   function hasSelectedOrActiveClass($el) {
     return $el && ($el.classList.contains("active") || $el.classList.contains("selected"));
   }

  function show($el) {
    if (!$el) return;
    $el.classList.remove("hide");
  }

  function hide($el) {
    if (!$el) return;
    $el.classList.add("hide");
  }

  function updateText($el, text) {
    $el.innerText = text;
  }

  function strikeText($el, strike) {
    $el.style.textDecoration = strike ? "line-through" : "none";
  }

  function isHidden($el) {
    if (!$el) return false;
    return (
      $el.classList.contains("hide") || !($el.offsetWidth || $el.offsetHeight || $el.getClientRects().length)
    );
  }

  function createErrorMessage(message) {
    return "smartrr: " + message + " Please contact support for assistance.";
  }
};
